var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    {
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "IconLinkItem",
                _vm._g(
                  {
                    key: "export_xccdf",
                    attrs: {
                      text: _vm.isResultView
                        ? "Export as XCCDF Results"
                        : "Export as XCCDF",
                      icon: "mdi-xml",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.exportXCCDF()
                      },
                    },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Export as XCCDF")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }